import * as angular from 'angular';
import ChatReport from './chat/chatReport';

// directives
import HighChart from './dashboard/dashboard.directives';
import ViewChat from './chat/viewChat.directive';
import FailedChecks from './checkLists/failedChecks.directive';
import HourlyCheckReport from './checkLists/hourlyCheckReport.directive';
import ScheduledCheckLists from './checkLists/scheduledCheckLists.directive';
import RecentCheckLists from './checks/recentCheckLists.directive';
import UnfinishedCheckLists from './checks/unfinishedCheckLists.directive';
import MoldDistributionGraph from './counts/equipmentGroupMoldDistributionGraph.directive';
import EquipmentRejectsGraph from './counts/equipmentGroupRejectsGraph.directive';
import TopDefects from './dashboard/topDefects.directive';
import TopDefectsGraph from './dashboard/topDefectsGraph.directive';
import TopRejectsGraph from './dashboard/topRejectsGraph.directive';
import BtnArray from './dashboard/btnArray.directive';

import Commodities from './batches/commodities.controller';
import BatchSummary from './batches/batchSummary.controller';
import BatchFormulas from './batches/batchFormulas.controller';
import BatchFormulaUsages from './batches/batchFormulaUsages.controller';
import BatchFormulaUsageReport from './batches/batchUsageReport.controller';
import CommodityBin from './batches/commodityBin.controller';

import CheckDetectorDefectMapping from './checkDetectorDefectMappings/checkDetectorDefectMapping.controller';
import CheckLists from './checkLists/checkLists.controller';
import CheckListKPI from './checkLists/checkListKPI.directive';
import CheckListReport from './checkLists/checkListReport.controller';
import CheckListReportReact from './checkLists/checkListReportReact';
import Checks from './checks/checks.controller';

import CountsHorizontalControllerName from './counts/count.controller';
import CountsHorizontalV2ControllerName from './counts/countv2.controller';
import CountsVerticalControllerName from './counts/countVertical.controller';
import CountsVerticalV2ControllerName from './counts/countVerticalv2.controller';
import PlantFeatureSettingsControllerName from './plants/plantFeatureSettings.controller';

import CountDetail from './counts/countDetail';

import CountSummary from './counts/summary.controller';
import AdminDashboard from './dashboard/adminDashboard.controller';
import Dashboard from './dashboard/dashboard.controller';
import ShopSummaryDashboard from './dashboard/shopSummaryDashboard.controller';
import PlantWareLossDashboard from './dashboard/plantWareLossDashboard.controller';
import ShopOperatorDashboard from './dashboard/shopOperatorDashboard.controller';
import GobWeightsGraph from './dashboard/gobWeightsGraph.directive';
import PlantDashboard from './dashboard/plantDashboard.controller';

import DefectTypesAdmin from './defectTypeAdmin/defectTypes.controller';
import DefectTypes from './defectTypes/defectTypes.controller';
import Alertroles from './alertRoles/alertRole.controller';
import EquipmentList from './equipment/equipmentList.controller';
import Formula from './formulas/formula.controller';
import Holidays from './holidays/holidays.controller';
import Jobs from './job/jobList.controller';
import JobRuns from './jobRun/jobRun.controller';
import LineConfig from './lineConfigs/lineConfigs.controller';
import LineEquipmentNames from './lineConfigs/lineEquipmentNames.controller';
import LineSheet from './linesheet/lineSheet.controller';
import SendNotification from './notifications/sendNotification.controller';
import Palletizers from './palletizers/palletizer.controller';
import PalletKpis from "./reports/palletKpis.controller";
import Plants from './plants/plants.controller';
import CavityEfficiencyReport from './reports/cavityEfficiencyReport.controller';
import CavityEfficiencyGraph from './reports/cavityEfficiencySummaryGraph.controller';
import CavityCorrelationReport from './reports/cavityCorrelationReport.controller';
import CavityCorrelationGraph from './reports/cavityCorrelationSummaryGraph.controller';

import FlexIsDetails from './machineDetails/flexIsDetails.controller';

import CommonReportLocationRow from './reports/commonReportLocationRow.directive';
import CommonReportQueryCriteriaRow from './reports/commonReportQueryCriteriaRow.directive';

import CriticalDefectReport from './reports/criticalDefectReport.controller';
import WareHeldReport from './reports/wareHeldReport.controller';
import TankMetricsReport from './reports/tankMetricsReport.controller';
import DefectsReport from './reports/defectsReport.controller';
import DeletedDefectsReport from './reports/deletedDefectReport.controller';
import DeletedGobWeightsReport from './reports/deletedGobWeightReport.controller';
import DowntimeReport from './reports/downtimeReport.controller';
import FurnacePullReport from './reports/furnacePullReport.controller';
import WeeklyKPIsReport from './reports/weeklyKPIsReport.controller';


import DropAndTimeLineGraphs from './reports/dropAndTimeLineGraphs.directive';

import HourlyCheckListReport from './reports/hourlyChecklistReport.controller';
import MorningMinutesReport from './reports/morningMinutesReport.controller';
import ShiftDetailReport from './reports/shiftDetailReport.controller';
import JobRunReport from './reports/jobRunReport.controller';
import ProductionReport from './reports/productionReport.controller';
import QualificationsReport from './reports/qualificationsReport.controller';
import RejectRateReport from './reports/rejectRateReport.controller';
import ShopCountSummaryReport from './reports/shopCountSummaryReport.controller';
import ToolChangeReport from './reports/toolChangeReport.controller';
import TopDefectsReport from './reports/topDefectsReport.controller';
import ResetPassword from './resetPassword/resetPassword.controller';
import RoleLocation from './roleLocation/roleLocation.controller';

import SectionChange from './sectionChange/sectionChange';

import Shops from './shops/shops.controller';
import SignIn from './signIn/signIn.controller';
import Users from './users/users.controller';
import TiamaDefectMappings from './tiamaDefectMappings/tiamaDefectMappings.controller';
import PlantPerformance from './dashboard/plantPerformance.controller';
import PlantPerformanceCharts from './dashboard/plantPerformanceCharts.controller';
import MachineDefectMappings from './machineDefectMappings/machineDefectMappings.controller';
import ProductionShiftReport from './reports/productionShiftReport.controller';
import ProductionShiftReportV2 from './reports/productionShiftReportV2.controller';
import DowntimeShiftReport from './reports/downtimeShiftReport.controller';
import downtimeShiftReportInsight from './reports/downtimeShiftReportInsight.controller';
import DumpGateTimeReportController from './reports/dumpGateTimeReport/dumpGateTimeReport.controller';
import ProductionKPIs from './dashboard/productionKPIs.controller';
import Measure from './dashboard/measure.controller';
import ScoreCardCheckList from './dashboard/scorecardChecklist.controller'
import hotEndBonusReport from "./reports/hotEndBonusReport.controller";

import CountsCavityCorrelationControllerName from './counts/ccc.controller';
import CountsCavityEfficiencyControllerName from './counts/cce.controller';
import DataPointHistoryReportControllerName from './reports/dataPointHistoryReport.controller';


let requires = [ChatReport, ViewChat, CheckDetectorDefectMapping, CheckLists, CheckListKPI, CheckListReport,
  CheckListReportReact, FailedChecks, HourlyCheckReport, ScheduledCheckLists, Checks, RecentCheckLists,
  UnfinishedCheckLists, MoldDistributionGraph, EquipmentRejectsGraph, CountSummary, Alertroles,
  AdminDashboard, Dashboard, GobWeightsGraph, PlantDashboard, TopDefects, TopDefectsGraph, TopRejectsGraph,
  DefectTypesAdmin, DefectTypes, EquipmentList, Formula, Holidays, Jobs, JobRuns, LineConfig, LineEquipmentNames,
  LineSheet, SendNotification, Palletizers, PalletKpis, Plants, CavityEfficiencyReport, CavityEfficiencyGraph, CavityCorrelationGraph,
  CavityCorrelationReport, CommonReportLocationRow, CommonReportQueryCriteriaRow, CriticalDefectReport, DefectsReport, DeletedDefectsReport, DowntimeReport,
  WareHeldReport, TankMetricsReport, WeeklyKPIsReport,
  FurnacePullReport, DropAndTimeLineGraphs, HourlyCheckListReport, JobRunReport, ProductionReport, QualificationsReport, RejectRateReport,
  ShopCountSummaryReport, ToolChangeReport, TopDefectsReport, ResetPassword, RoleLocation, SectionChange, Shops,
  SignIn, Users, MorningMinutesReport, ShiftDetailReport, DeletedGobWeightsReport, TiamaDefectMappings, PlantPerformance, PlantPerformanceCharts,
  MachineDefectMappings, ShopSummaryDashboard, PlantWareLossDashboard, ShopOperatorDashboard, HighChart,
  ProductionShiftReport,
  ProductionShiftReportV2,
  DowntimeShiftReport,
  downtimeShiftReportInsight,
  DumpGateTimeReportController,
  ProductionKPIs,
  Measure,
  ScoreCardCheckList,
  hotEndBonusReport,
  FlexIsDetails,

  CountsHorizontalControllerName,
  CountsHorizontalV2ControllerName,
  CountsVerticalControllerName,
  CountsVerticalV2ControllerName,
  CountsCavityCorrelationControllerName,
  CountsCavityEfficiencyControllerName,
  CountDetail,

    Commodities, BatchFormulas, BatchFormulaUsages, BatchFormulaUsageReport, CommodityBin, BatchSummary,

  DataPointHistoryReportControllerName,
  PlantFeatureSettingsControllerName
];

requires.push(BtnArray);

export default angular.module('aps.controllers', requires).name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/app/controllers/index.ts